'use strict';

var url = require('url');

module.exports = function (uri1, uri2, ieMode) {
  if (uri1 === uri2) {
    return true;
  }

  var url1 = url.parse(uri1, false, true);
  var url2 = url.parse(uri2, false, true);
  var url1Port = url1.port | 0 || (url1.protocol === 'https' ? 443 : 80);
  var url2Port = url2.port | 0 || (url2.protocol === 'https' ? 443 : 80);
  var match = {
    proto: url1.protocol === url2.protocol,
    hostname: url1.hostname === url2.hostname,
    port: url1Port === url2Port
  };
  return match.proto && match.hostname && (match.port || ieMode);
};